export let PlayerManager = {
  player: null,
  videoJSPlayerNode: null,
  playerNode() {
    // it might happen that player container changes - see interactive open publication
      return this.videoJSPlayerNode;
  },
  nativeHtml5VideoNode: null,
  /**
   * Get the actual video element that's rendering content.
   * For IVS live streams, this is the IVS player's internal video element.
   * For on-demand video, this is the native HTML5 video element.
   * @param {boolean} ivsMode - Whether IVS mode is active
   * @returns {HTMLVideoElement|null}
   */
  getVideoElement(ivsMode) {
    if (ivsMode && this.player) {
      try {
        const ivsPlayer = this.player.getIVSPlayer();
        if (ivsPlayer) {
          const ivsVideoElement = ivsPlayer.getHTMLVideoElement();
          if (ivsVideoElement) {
            return ivsVideoElement;
          }
        }
      } catch (e) {
        console.warn('Failed to get IVS video element:', e);
      }
    }
    return this.nativeHtml5VideoNode;
  },
  play() {
    this.player.play()
  },
  pause() {
    this.player.pause()
  },
  stop() {
    this.player.pause()
    this.player.currentTime(0)
  },
  seek(offset) {
    this.player.currentTime(offset)
  },
  duration() {
    return this.player.duration()
  },
  isMute() {
    return this.player.muted();
  },
  setMute(value) {
    this.player.muted(!!value);
  },
  getVolume() {
    return Math.round(this.player.volume() * 100)
  },
  setVolume(value) {
    // integer between 0 - 100
    this.player.volume(value / 100)
  },
  getPosition() {
    return this.player.currentTime()
  },
  onVolumeChange(callback) {
    this.player.on("volumechange", callback);
  },
  paused() {
    return this.player.paused();
  },
  bufferPercentage() {
    return Math.round(PlayerManager.player.bufferedPercent() * 100);
  },
  destroy() {
    this.player.dispose();
  },
  qualityLevels(ivsMode) {
    if (ivsMode) {
      return this.player.getIVSPlayer().getQualities();
    }
    return this.player.qualityLevels();
  },
  getQualityLevel(ivsMode) {
    if (ivsMode) {
      return this.player.getIVSPlayer().getQuality();
    }

    const qualityLevels = this.player.qualityLevels();
    return qualityLevels[qualityLevels.selectedIndex];

  },
  setQualityLevel(qualityLevel, ivsMode, index) {
    if (ivsMode) {
      this._setIvsQualityLevel(qualityLevel, index);
      return;
    }
    this._setVideoJSQualityLevel(qualityLevel, index);
  },
  _setIvsQualityLevel(qualityLevel, index) {
    if (index === this.qualityLevels(true).length) {
      this.player.getIVSPlayer().setAutoQualityMode(true);
    } else {
      this.player.getIVSPlayer().setAutoQualityMode(true);
      this.player.getIVSPlayer().setQuality(qualityLevel);
    }
  },
  _setVideoJSQualityLevel(qualityLevel, index) {
    const listLength = this.player.qualityLevels().length;
    for (let i = 0; i < listLength; i++) {
      if (index < listLength) {
        this.player.qualityLevels()[i].enabled = i === index;
      } else {
        this.player.qualityLevels()[i].enabled = true;
      }
    }

    const validatedSelectedIndex = index < listLength ? index : index -1;

    this.player.qualityLevels().selectedIndex_ = validatedSelectedIndex;
    this.player.qualityLevels().trigger({type: 'change', selectedIndex: validatedSelectedIndex});
  }
}

// https://docs.videojs.com/player#reset